import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { API_BASE_URL } from '../config';
import { buildProfessionalDualModeKey } from '../utils/professionalDualModeStorage';

export default function ProfessionalLoginChoice() {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(true);
  const [profile, setProfile] = useState(null);

  useEffect(() => {
    let mounted = true;
    (async () => {
      try {
        const token = localStorage.getItem('authToken');
        const headers = token ? { Authorization: `Bearer ${token}` } : {};

        const meRes = await fetch(`${API_BASE_URL}/auth/me`, {
          credentials: 'include',
          headers,
        });
        const me = meRes.ok ? await meRes.json().catch(() => ({})) : null;
        if (me?.isAdmin) {
          navigate('/dashboard', { replace: true });
          return;
        }

        const res = await fetch(`${API_BASE_URL}/api/professional/profile`, {
          credentials: 'include',
          headers,
        });
        if (!mounted) return;
        if (!res.ok) {
          navigate('/dashboard', { replace: true });
          return;
        }
        const data = await res.json().catch(() => ({}));
        if (!data?.exists || !data?.profile?.professionalType) {
          navigate('/dashboard', { replace: true });
          return;
        }
        const userId = data.profile.userId;
        const key = buildProfessionalDualModeKey(userId);
        const choice = key ? localStorage.getItem(key) : null;
        if (choice) {
          const panelPath = data.profile.professionalType === 'pt' ? '/pt-panel' : '/diyetisyen-panel';
          navigate(choice === 'yes' ? '/dashboard' : panelPath, { replace: true });
          return;
        }
        setProfile(data.profile);
      } finally {
        if (mounted) setLoading(false);
      }
    })();
    return () => {
      mounted = false;
    };
  }, [navigate]);

  const handleChoice = (choice) => {
    if (!profile?.userId) return;
    const key = buildProfessionalDualModeKey(profile.userId);
    if (key) localStorage.setItem(key, choice);
    const panelPath = profile.professionalType === 'pt' ? '/pt-panel' : '/diyetisyen-panel';
    navigate(choice === 'yes' ? '/dashboard' : panelPath, { replace: true });
  };

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-white dark:bg-[#1a1a1a]">
        <div className="text-sm text-slate-500 dark:text-slate-300">Yükleniyor...</div>
      </div>
    );
  }

  return (
    <div className="min-h-screen flex items-center justify-center bg-white dark:bg-[#1a1a1a] px-4">
      <div className="w-full max-w-lg rounded-2xl border border-cyan-200 bg-cyan-50 p-6 shadow-xl dark:border-cyan-900/40 dark:bg-cyan-900/20">
        <h1 className="text-xl font-black text-cyan-900 dark:text-cyan-100">
          Siz de sistemi standart kullanıcı olarak kullanmak ister misiniz?
        </h1>
        <p className="mt-2 text-sm text-cyan-800 dark:text-cyan-200">
          Evet derseniz kendi mutfağınızı ve günlük menü akışını da kullanabilirsiniz.
        </p>
        <div className="mt-5 flex flex-wrap gap-3">
          <button
            onClick={() => handleChoice('yes')}
            className="rounded-xl bg-cyan-700 px-4 py-2 text-sm font-bold text-white hover:bg-cyan-800"
          >
            Evet, kullanmak istiyorum
          </button>
          <button
            onClick={() => handleChoice('no')}
            className="rounded-xl border border-cyan-300 px-4 py-2 text-sm font-bold text-cyan-800 hover:bg-cyan-100 dark:border-cyan-700 dark:text-cyan-200 dark:hover:bg-cyan-900/30"
          >
            Hayır, panelime geç
          </button>
        </div>
      </div>
    </div>
  );
}
